import { render } from "./wowPage.vue?vue&type=template&id=78e397ef"
import script from "./wowPage.vue?vue&type=script&lang=js"
export * from "./wowPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__